'use client';

import { useTranslation } from 'react-i18next';

import MediaPartners from '@/app/components/MediaPartners/MediaPartners';
import FooterNavigation from '@/app/components/FooterNavigation/FooterNavigation';
import SocialNavigation from '@/app/components/SocialNavigation/SocialNavigation';
import PaymentMethodLogos from '@/app/components/PaymentMethodLogos/PaymentMethodLogos';
import { countryConfig } from '@/app/utils/countryConfig';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="w-full max-w-[1128px] my-0 mx-auto py-[32px] px-[24px] lg:px-0">
      <MediaPartners className="mb-[80px] lg:mb-[120px]" />
      <FooterNavigation />
      <div className="flex flex-col lg:flex-row lg:justify-between mb-[32px] gap-[48px] lg:items-center">
        <SocialNavigation />
        <PaymentMethodLogos />
      </div>
      {countryConfig.ounwerShipNoteTranslationKey && (
        <p className="text-neutral-semiTransparent mb-[16px]">{t(countryConfig.ounwerShipNoteTranslationKey)}</p>
      )}
      <p className="text-neutral-semiTransparent mb-[16px]">
        {t('components.Footer.copyright', { year: new Date().getFullYear() })}
      </p>
    </footer>
  );
};

export default Footer;
